export const findActionDefinition = (actionsList, actionType) => {
  if (!actionType) return null;

  for (const integration of Object.values(actionsList || {})) {
    const actionTypes = integration?.action_types;
    if (!Array.isArray(actionTypes)) continue;

    const definition = actionTypes.find(
      (item) => item.action_type === actionType
    );
    if (definition) {
      return {
        ...definition,
        integration_type:
          definition.integration_type || integration.integration_type,
        plan_tier: definition.plan_tier || integration.plan_tier,
      };
    }
  }

  return null;
};

export const actionHasSettings = (actionsList, actionType) => {
  const definition = findActionDefinition(actionsList, actionType);

  return Boolean(
    definition &&
      Array.isArray(definition.settings) &&
      definition.settings.length > 0
  );
};
